/** Tipos de dívida que abatem o patrimônio (Art. 1.847 CC) — composição do patrimônio. */
export const TIPOS_DIVIDA_QUE_ABATEM = new Set<string>([
  'emprestimo',
  'outros',
  'despesa_inventario',
  'despesa_funeral',
  'passivo_bem',
]);

export const TIPO_DESPESA_INFORMATIVA_LABEL: Record<string, string> = {
  cartorio_inventario_pago: 'Cartório do Inventário (pago)',
  honorarios_inventario_pago: 'Honorários do Inventário (pago)',
};

export const TIPO_ITEM_FORA_ESCOPO_LABEL: Record<string, string> = {
  despesa_inventario_anterior: 'Inventário anterior',
  despesa_pos_partilha: 'Pós-Partilha',
};
